import {Button} from '@wandb/weave/components';
import React, {memo, useCallback, useState} from 'react';

import {useProjectParams} from '../../pages/ProjectPage/useProjectParams';
import TableExport from '../TableExport';
import * as S from './RunsDownloadMenu.styles';
import {RunsExportAPI} from './RunsExportAPI';

type RunsDownloadMenuProps = {
  pageQuery: any;
  tableSettings: any;
};

const RunsDownloadMenuComp: React.FC<RunsDownloadMenuProps> = ({
  pageQuery,
  tableSettings,
}) => {
  const {entityName, projectName} = useProjectParams();
  const [downloadMenuOpen, setDownloadMenuOpen] = useState(false);
  const [CSVModalOpen, setCSVModalOpen] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  // download menu controls
  const openDownloadMenu = useCallback(() => {
    setDownloadMenuOpen(true);
  }, []);
  const closeDownloadMenu = useCallback(() => {
    setDownloadMenuOpen(false);
  }, []);

  // CSV export modal controls
  const openCSVModal = useCallback(() => {
    setDownloadMenuOpen(false);
    setCSVModalOpen(true);
  }, []);
  const closeCSVModal = useCallback(() => {
    setCSVModalOpen(false);
  }, []);

  // export API modal controls
  const openExportModal = useCallback(() => {
    setDownloadMenuOpen(false);
    setExportModalOpen(true);
  }, []);
  const closeExportModal = useCallback(() => {
    setExportModalOpen(false);
  }, []);

  const menuOptions = [
    {
      key: 'export-api',
      label: 'Export API',
      onClick: openExportModal,
    },
    {
      key: 'csv-export',
      label: 'CSV Export',
      onClick: openCSVModal,
    },
  ];

  return (
    <>
      <S.DownloadMenu
        basic
        position="bottom left"
        on="click"
        open={downloadMenuOpen}
        onOpen={openDownloadMenu}
        onClose={closeDownloadMenu}
        popperModifiers={{
          preventOverflow: {enabled: false},
        }}
        trigger={
          <Button
            active={downloadMenuOpen}
            variant="secondary"
            icon="download"
            aria-label="Toggle export menu"
          />
        }
        content={
          <>
            {menuOptions.map(o => (
              <div key={o.key} onClick={o.onClick}>
                {o.label}
              </div>
            ))}
          </>
        }
      />
      <RunsExportAPI
        entityName={entityName}
        projectName={projectName}
        open={exportModalOpen}
        onClose={closeExportModal}
      />
      <TableExport
        pageQuery={pageQuery}
        tableSettings={tableSettings}
        open={CSVModalOpen}
        onClose={closeCSVModal}
      />
    </>
  );
};

export const RunsDownloadMenu = memo(RunsDownloadMenuComp);
